import { FahrlehrerCh } from '@/src/@types/blinkadmin'
import Picture from '@/src/components/elements/Picture'
import Container from '@/src/components/layout/Container'

const Images = ({ images }: FahrlehrerCh.TeacherProfile) => {
  const imgs = images.slice(0, 4)
  if (imgs.length === 0) return null

  const [img0, img1, img2, img3] = imgs

  return (
    <section id="images">
      <Container className="mt-20 md:mt-24">
        <h2 className="text-4xl font-black md:text-10xl">Bilder</h2>
        {imgs.length === 1 && (
          <div className="relative mt-6 h-70 overflow-hidden rounded-lg bg-gray-150 md:h-120">
            <Picture
              permalink={img0.url}
              fill
              alt={img0.description ?? ''}
              className="object-cover"
              sizes="100vw"
            />
          </div>
        )}
        {imgs.length === 2 && (
          <div className="mt-6 grid grid-cols-1 gap-3 md:h-120 md:grid-cols-2 md:grid-rows-1">
            <div className="relative h-70 overflow-hidden rounded-lg bg-gray-150 md:h-auto">
              <Picture
                permalink={img0.url}
                fill
                alt={img0.description ?? ''}
                className="object-cover"
                sizes="(min-width: 768px) 50vw, 100vw"
              />
            </div>
            <div className="relative h-70 overflow-hidden rounded-lg bg-gray-150 md:h-auto">
              <Picture
                permalink={img1.url}
                fill
                alt={img1.description ?? ''}
                className="object-cover"
                sizes="(min-width: 768px) 50vw, 100vw"
              />
            </div>
          </div>
        )}
        {imgs.length === 3 && (
          <div className="mt-6 grid grid-cols-1 gap-3 md:h-120 md:grid-cols-12 md:grid-rows-2">
            <div className="relative h-70 overflow-hidden rounded-lg bg-gray-150 md:col-span-7 md:row-span-2 md:h-auto">
              <Picture
                permalink={img0.url}
                fill
                alt={img0.description ?? ''}
                className="object-cover"
                sizes="(min-width: 768px) 58vw, 100vw"
              />
            </div>
            <div className="relative h-70 overflow-hidden rounded-lg bg-gray-150 md:col-span-5 md:h-auto">
              <Picture
                permalink={img1.url}
                fill
                alt={img1.description ?? ''}
                className="object-cover"
                sizes="(min-width: 768px) 42vw, 100vw"
              />
            </div>
            <div className="relative h-70 overflow-hidden rounded-lg bg-gray-150 md:col-span-5 md:h-auto">
              <Picture
                permalink={img2.url}
                fill
                alt={img2.description ?? ''}
                className="object-cover"
                sizes="(min-width: 768px) 42vw, 100vw"
              />
            </div>
          </div>
        )}
        {imgs.length >= 4 && (
          <div className="mt-6 grid grid-cols-1 gap-3 md:h-120 md:grid-cols-4 md:grid-rows-2">
            <div className="relative h-70 overflow-hidden rounded-lg bg-gray-150 md:col-span-2 md:row-span-2 md:h-auto">
              <Picture
                permalink={img0.url}
                fill
                alt={img0.description ?? ''}
                className="object-cover"
                sizes="(min-width: 768px) 50vw, 100vw"
              />
            </div>
            <div className="relative h-70 overflow-hidden rounded-lg bg-gray-150 md:col-span-2 md:h-auto">
              <Picture
                permalink={img1.url}
                fill
                alt={img1.description ?? ''}
                className="object-cover"
                sizes="(min-width: 768px) 50vw, 100vw"
              />
            </div>
            <div className="relative h-70 overflow-hidden rounded-lg bg-gray-150 md:h-auto">
              <Picture
                permalink={img3.url}
                fill
                alt={img3.description ?? ''}
                className="object-cover"
                sizes="(min-width: 768px) 25vw, 100vw"
              />
            </div>
            <div className="relative h-70 overflow-hidden rounded-lg bg-gray-150 md:h-auto">
              <Picture
                permalink={img2.url}
                fill
                alt={img2.description ?? ''}
                className="object-cover"
                sizes="(min-width: 768px) 25vw, 100vw"
              />
            </div>
          </div>
        )}
      </Container>
    </section>
  )
}

export default Images
